module.exports = __webpack_public_path__ + "img/4.1d08a392.png";